import React from 'react';
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link, MenuItem, Box, Card, CardContent, Select, TextField, Button, Typography } from '@mui/material';
import { useApi} from '/@/app/Api';
import { Spinner } from '/@/app/components/Spinner';
import { messageStackState } from "/@/app/states/messageStackState";
import { userFlowState } from "/@/app/states/userFlowState.js";
import { route } from '/@/app/routes';


export const ProfdataImportBar = ({ sx }) => {
    const api=useApi();
    const [importing, setImporting] = useState(false);

    const [order, setOrder] = useState('');
    const [orderError, setOrderError] = useState(null);
    const [lab, setLab] = useState('');
    const [labError, setLabError] = useState(null);

    const handleLabChange = (event) => {
        setLab(event.target.value);
        setLabError(null);
    }
    const handleOrderChange = (event) => {
        setOrder(event.target.value);
        if (event.target.value) {
            setOrderError(null);
        }
    }

    const handleClick = () => {
        if (importing) {
            return; // prevent double-click
        }
        if (!order) {
            setOrderError('Введите номер заявки');
            return;
        }
        if (!lab) {
            setLabError('Выберите лабораторию');
            return;
        }
        setImporting(true);
        api.request(
            'cabinet/panels/lab-import/',
            {
                    order: order,
                    lab: lab,
            },
            {
                method: 'POST',
                silentStatuses: {
			400: (error) => {
			    messageStackState.addMessage({
				text: error.data.detail,
				tags: 'error',
				autoHide: null,  // dont auto-hide
			    });
			}
	        }
            }
        ).then(data => {
            if (data.results_recalculated) {
                messageStackState.addMessage({
                    text: "Данные успешно загружены. План продления жизни рассчитан. Обновляем страницу.",
                    tags: "success",
                });
            }
            if (data.calculate_required) {
                userFlowState.setCalculateRequired({
                    isRequired: true,
                });
                messageStackState.addMessage({
                    text: "Данные успешно загружены.",
                    tags: "warning",
                });
            }
            location.reload();
        }).finally(() => {
            setImporting(false);
        });
    }


    return (
        <Box sx={{...sx}}>
            <Typography variant="body1" sx={{ textAlign: "center" }}>
                Загрузить данные <Link component={RouterLink} to={route('/labs/')}>из лаборатории</Link>
            </Typography>
            <Box sx={{
                display: 'flex',
                flexFlow: 'row wrap',
                alignItems: 'flex-start',
                justifyContent: 'center',
                gap: '10px',
            }}>
                <TextField
                    value={order}
                    onChange={handleOrderChange}
                    label="Номер заявки"
                    variant="outlined"
                    sx={{
                        flexGrow: "1",
                        maxWidth: "300px",
                        input: {
                            textAlign: 'left',
                            borderRadius: '15px',
                            pr: '20px',
                            pl: '60px',
                        },
                    }}
                    error={orderError !== null}
                    helperText={orderError}
                />
                <Select
                    value={lab}
                    onChange={handleLabChange}
                    sx={{
                        flexGrow: "1",
                        maxWidth: "120px",
                    }}
                    error={labError !== null}
                >
                    <MenuItem value="dnkom">ДНКОМ</MenuItem>
                    <MenuItem value="aqua_lab">Aqua Lab</MenuItem>
                    {/* not used anymore
                    <MenuItem value="bonetsky_lab">Лаборатория Бонецкого</MenuItem>
                    */}
                </Select>

                <Button
                    variant="contained"
                    onClick={handleClick}
                    sx={{ height: "56px" }}
                >
                    {importing
                        ? <Spinner size={40} delay={0} sx={{color: "white"}} />
                        : <>Загрузить</>
                    }
                </Button>
            </Box>
        </Box>
    )
}
